export const currency = ['USD'];
